module.exports = __webpack_public_path__ + "static/img/manual-2.4e9f107.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-2.png
// module id = XiyT
// module chunks = 4